import styled from '@emotion/styled'
import tw from 'twin.macro'

export const BagProductsList = styled.ul`
  ${tw`w-full text-lg divide-y divide-grey-300`}
  li {
    ${tw`py-4`}
  }
`
